import React from 'react'
import { Heading, LayoutPageWrapper } from 'goustouicomponents'
import { BENEFITS } from '../../config'
import { splitOnLineBreak } from '../../utils/splitOnLineBreak'
import css from './Benefits.module.css'

const Benefits = () => {
  const perks = BENEFITS.map((benefit, index) => (
    <li key={benefit.description} className={css.benefitItem}>
      <img src={BENEFITS[index].icon} className={css.benefitIcon} alt={benefit.description} />
      {splitOnLineBreak(BENEFITS[index].description)}
    </li>
  ))

  return (
    <section className={css.wrapper}>
      <LayoutPageWrapper>
        <div className={css.textWrapper}>
          <Heading type="h2" size="fontStyleXL">
            Benefits
          </Heading>
          <p>Who says there’s no such thing as a free lunch?</p>
        </div>
        <ul className={css.perksContainer}>{perks}</ul>
      </LayoutPageWrapper>
    </section>
  )
}

export { Benefits }
